import { Box, Skeleton } from "@mui/material";
import React, { FC } from "react";

interface ThumbnailProps {
  imageUrl?: string;
  fallback?: React.ReactNode;
  loading: boolean;
  size?: number; // pixels
}

export const Thumbnail: FC<ThumbnailProps> = ({ imageUrl, loading, fallback, size }) => {
  if (imageUrl !== undefined) {
    return (
      <img
        alt=""
        src={imageUrl}
        style={{ width: size ? `${size}px` : "100%", height: size ? `${size}px` : "100%", objectFit: "contain" }}
      />
    );
  }

  if (loading) {
    return (
      <Box component="div" sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Skeleton variant="circular" width="70%" height="70%" />
      </Box>
    );
  }

  if (fallback !== undefined) {
    return (
      <Box component="div" sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
        {fallback}
      </Box>
    );
  }

  return <></>;
};
